import {
  Brain,
  ShieldCheck,
  Rocket,
  Bell,
  ChartBar,
  Star,
} from "@phosphor-icons/react";

const items = [
  { icon: Brain, label: "AI-Powered Analysis" },
  { icon: ShieldCheck, label: "Risk Intelligence" },
  { icon: Rocket, label: "Presale Intelligence" },
  { icon: Bell, label: "Smart Monitoring" },
  { icon: ChartBar, label: "Paper Trading" },
  { icon: Star, label: "Portfolio & Watchlist" },
];

export const TrustStrip = () => {
  const row = [...items, ...items];
  return (
    <section
      className="relative z-10 overflow-hidden border-y border-white/8 bg-white/[0.015] py-6"
      data-testid="trust-strip"
      aria-label="Core capabilities"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-midnight to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-midnight to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-12">
        {row.map((it, i) => (
          <div key={i} className="flex shrink-0 items-center gap-3" aria-hidden={i >= items.length}>
            <it.icon size={20} weight="duotone" className="text-teal-400" />
            <span className="whitespace-nowrap font-display text-base font-semibold text-white/80">
              {it.label}
            </span>
            <span className="ml-9 h-1.5 w-1.5 rounded-full bg-teal-500/40" />
          </div>
        ))}
      </div>
    </section>
  );
};
